import { DeclarationItem, RAAOption } from "core/types";

export const LOGO_IMG = {
    GROWW_LOGO_LIGHT: 'https://resources.groww.in/web-assets/img/website-logo/groww-logo-light.svg',
    GROWW_LOGO_DARK: 'https://resources.groww.in/web-assets/img/website-logo/groww-logo-dark.svg',
}

export const JOURNEY_TYPES = {
    MAIN_ONBOARDING: 'MAIN_ONBOARDING',
    HUF_ONBOARDING: 'HUF_ONBOARDING',
    FNO_INCOME_PROOF_DOC_UPLOAD: 'FNO_INCOME_PROOF_DOC_UPLOAD',
    EMAIL_UPDATE: 'EMAIL_UPDATE',
    MOBILE_CHANGE: 'MOBILE_CHANGE',
    DEMAT_CLOSURE: 'DEMAT_CLOSURE',
    NOMINEE: 'NOMINEE_ADDITION',

    NIO_ONBOARDING: 'NIO_ONBOARDING',

    PARENTS_NAME_UPDATE: 'PARENTS_NAME_UPDATE',
    MARITAL_STATUS_UPDATE: 'MARITAL_STATUS_UPDATE',
    INCOME_RANGE_UPDATE: 'INCOME_RANGE_UPDATE',
    MF_NOMINEE_EDIT: 'MF_NOMINEE_EDIT',
    MF_NOMINEE_ADD: 'MF_NOMINEE_ADDITION',
    STOCKS_NOMINEE_ADD: 'STOCKS_NOMINEE_ADDITION',
    STOCKS_NOMINEE_EDIT: 'STOCKS_NOMINEE_EDIT',
    ALL_INVESTMENTS_ADD: 'ALL_INVESTMENTS_NOMINEE_ADDITION',
    ALL_INVESTMENTS_EDIT: 'ALL_INVESTMENTS_NOMINEE_EDIT',
    EMAIL_CHANGE: 'EMAIL_CHANGE',

    DDPI: 'DDPI'
};

export const SEARCH_PARAMS = {
    DIGIO_DOC_ID: 'digio_doc_id',
    DATA_TYPE: 'dataType',
    STATUS: 'status',
    SUCCESS: 'success',
    JOURNEY_TYPES: 'journeyType',
    MODE: 'MODE',
    CALLBACK_REDIRECTION: 'callbackRedirection',
}

export const AOF_STATUS = {
    NOT_CREATED: 'NOT_CREATED',
    VERIFIED: 'VERIFIED',
    CREATED: 'CREATED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    INACTIVE: 'INACTIVE',
};

export const FNO_ONBOARDING_SCREENS = {
    CONGRATULATIONS: 'CONGRATULATIONS',
    BANK_SELECTION: 'BANK_SELECTION',
    USER_BANK_LIST: 'USER_BANK_LIST',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    BUSINESS_FLAG: 'BUSINESS_FLAG',
};

export const ONBOARDING_FLOW_SCREENS = {
    PAN_AUTO_FETCH_SCREEN: 'PAN_AUTO_FETCH_SCREEN',
    PAN_INPUT_SCREEN: 'PAN_INPUT_SCREEN',
    NAME_INPUT_SCREEN: 'NAME_INPUT_SCREEN',
    NAME_AUTO_FETCH_SCREEN: 'NAME_AUTO_FETCH_SCREEN',
    PAN_NO_CONFIRMATION: 'PAN_NO_CONFIRMATION',
    DOB_SCREEN: 'DOB_SCREEN',
    NAME_MISMATCH_SCREEN: 'NAME_MISMATCH_SCREEN',
    AUTO_FETCH_BANK: 'AUTO_FETCH_BANK',
    BANK_RPD_SCREEN: 'BANK_RPD_SCREEN',
    BANK_PD_SCREEN: 'BANK_PD_SCREEN',
    OCCUPATION_SCREEN: 'OCCUPATION_SCREEN',
    GENDER_SELECTION_SCREEN: 'GENDER_SELECTION_SCREEN',
    FATHERS_NAME_SCREEN: 'FATHERS_NAME_SCREEN',
    TRADING_EXPERIENCE_SCREEN: 'TRADING_EXPERIENCE_SCREEN',
    PROOF_OF_IDENTITY: 'PROOF_OF_IDENTITY',
    DIGILOCKER: 'DIGILOCKER',
    EKYC_VERIFICATION_SCREEN: 'EKYC_VERIFICATION_SCREEN',
    LOCATION_VALIDATION: 'LOCATION_VALIDATION',
    KYC_DECLARATION: 'KYC_DECLARATION',
    SELFIE: 'SELFIE',
    ADDRESS_TEXT: 'ADDRESS_TEXT',
    SIGNATURE: 'SIGNATURE',
    MANUAL_DOC_UPLOAD: 'MANUAL_DOC_UPLOAD',
    ONBOARDING_PENDING_SCREEN: 'ONBOARDING_PENDING_SCREEN',
    EMAIL_INPUT: 'EMAIL_INPUT',
    MOBILE_INPUT: 'MOBILE_INPUT',
    MOBILE_OTP: 'MOBILE_OTP',
    IPV: 'IPV',
    ESIGN: 'ESIGN',
    INCOME_PROOF: 'INCOME_PROOF',
    HUF: 'HUF',
    NOMINEE_ADDITION: 'NOMINEE_ADDITION',
    NOMINEE_EDIT_OTP: 'NOMINEE_EDIT_OTP',
    MARITAL_STATUS: 'MARITAL_STATUS',
    INCOME_RANGE: 'INCOME_RANGE',
    COPARCENER_DETAIL_SCREEN: 'COPARCENER_DETAIL_SCREEN',
    LOADING: 'LOADING',
    FAILURE: 'FAILURE',
    FNO_CONFIRMATION_SCREEN: 'FNO_CONFIRMATION_SCREEN',
    SUCCESS_SCREEN: 'SUCCESS_SCREEN'
};

export const PIRIMID_EVENT_CODES = {
    CONSENT_APPROVED_SUCCESS: 'CONSENT_APPROVED_SUCCESS',
    CONSENT_REJECTED_SUCCESS: 'CONSENT_REJECTED_SUCCESS',
    CONSENT_APPROVED_FAILED: 'CONSENT_APPROVED_FAILED',
    CONSENT_REJECTED_FAILED: 'CONSENT_REJECTED_FAILED',
    CONSENT_NOT_IN_PENDING_STATE: 'CONSENT_NOT_IN_PENDING_STATE',
    NO_ACCOUNTS_FOUND: 'NO_ACCOUNTS_FOUND',
    BACK_BUTTON_CLICKED: 'BACK_BUTTON_CLICKED',
    IFRAME_FAILED: 'IFRAME_FAILED',
    JOURNEY_COMPLETED: 'JOURNEY_COMPLETED',
    JOURNEY_SKIPPED: 'JOURNEY_SKIPPED',
};

export const ONB_REDIRECTION_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};

export const RESET_JOURNEY_STATUS = {
    DATA_COLLECTION_JOURNEY_RESET_COMPLETED: 'DATA_COLLECTION_JOURNEY_RESET_COMPLETED'
}

export const INCOME_DATA = [
    { value: 'H', label: 'More than 5 Crores' },
    { value: 'G', label: '1 Crore - 5 Crores' },
    { value: 'F', label: '50 Lakh - 1 Crore' },
    { value: 'E', label: '25 Lakh - 50 Lakh' },
    { value: 'D', label: '10 Lakh - 25 Lakh' },
    { value: 'C', label: '5 Lakh - 10 Lakh' },
    { value: 'B', label: '1 Lakh - 5 Lakh' },
    { value: 'A', label: 'Upto 1 Lakh' },
];

export const TRADING_EXPERIENCE = [
    { value: 'A', label: 'No Experience' },
    { value: 'B', label: '1 Year' },
    { value: 'C', label: '2 Years' },
    { value: 'D', label: '3 Years' },
    { value: 'E', label: '4 Years' },
    { value: 'F', label: '5+ Years' },
];

export const GENDER_DATA = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
    { value: 'NA', label: 'Other' },
];

export const RELATION_DATA_BASIS_GENDER = {
    MALE: [
        { value: 'SON', label: 'Son' },
        { value: 'HUSBAND', label: 'Husband' },
        { value: 'FATHER', label: 'Father' },
        { value: 'BROTHER', label: 'Brother' },
        { value: 'GRAND_SON', label: 'Grand Son' },
        { value: 'GRAND_FATHER', label: 'Grand Father' },
    ],
    FEMALE: [
        { value: 'DAUGHTER', label: 'Daughter' },
        { value: 'WIFE', label: 'Wife' },
        { value: 'MOTHER', label: 'Mother' },
        { value: 'SISTER', label: 'Sister' },
        { value: 'GRAND_DAUGHTER', label: 'Grand Daughter' },
        { value: 'GRAND_MOTHER', label: 'Grand Mother' },
    ],
    NA: [
        { value: 'SON', label: 'Son' },
        { value: 'HUSBAND', label: 'Husband' },
        { value: 'FATHER', label: 'Father' },
        { value: 'BROTHER', label: 'Brother' },
        { value: 'DAUGHTER', label: 'Daughter' },
        { value: 'WIFE', label: 'Wife' },
        { value: 'MOTHER', label: 'Mother' },
        { value: 'SISTER', label: 'Sister' },
        { value: 'GRAND_SON', label: 'Grand Son' },
        { value: 'GRAND_DAUGHTER', label: 'Grand Daughter' },
        { value: 'GRAND_FATHER', label: 'Grand Father' },
        { value: 'GRAND_MOTHER', label: 'Grand Mother' },
    ],
};

export const RELATION_DATA = [
    { value: 'SON', label: 'Son' },
    { value: 'DAUGHTER', label: 'Daughter' },
    { value: 'WIFE', label: 'Wife' },
    { value: 'FATHER', label: 'Father' },
    { value: 'MOTHER', label: 'Mother' },
];

export const MAX_COPARCENER_MEMBERS = 10;

export const MARITAL_STATUS = [
    { value: 'SINGLE', label: 'Single' },
    { value: 'MARRIED', label: 'Married' },
];
export const OCCUPATION_DATA = [
    { value: 'PRIVATE_SECTOR_SERVICE', label: 'Private Sector Service' },
    { value: 'PUBLIC_SECTOR_SERVICE', label: 'Public Sector Service' },
    { value: 'GOVERNMENT_SERVICE', label: 'Government Service' },
    { value: 'HOUSEWIFE', label: 'Housewife' },
    { value: 'STUDENT', label: 'Student' },
    { value: 'SELF_EMPLOYED', label: 'Self Employed' },
    { value: 'BUSINESS', label: 'Business' },
    { value: 'PROFESSIONAL', label: 'Professional' },
    { value: 'RETIRED', label: 'Retired' },
    { value: 'FARMER', label: 'Farmer' },
    { value: 'SERVICE', label: 'Service' },
    { value: 'AGRICULTURIST', label: 'Agriculturist' },
];

export const API_GENERAL_STATUS = {
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};

export const DOC_UPLOAD_STATUS = {
    PENDING: 'PENDING',
    INITIATED: 'INITIATED',
    FAILED: 'FAILED',
    VERIFIED: 'VERIFIED',
    REJECTED: 'REJECTED',
    VERIFICATION_PENDING: 'VERIFICATION_PENDING',
    ENCRYPTED_RETRY: 'ENCRYPTED_RETRY',
    DECRYPTION_FAILED: 'DECRYPTION_FAILED',
    SKIPPED: 'SKIPPED',
};

export const GENERAL_ERROR_CONSTANTS = {
    GENERAL_ERROR: 'Something went wrong. Please try again.',
};

export const TRACKPAD_SCREEN_ERRORS = {
    SIGNATURE_NOT_FOUND: 'Signature not found please sign in the frame',
    SIGNATURE_UNCLEAR:
        'Signature is unclear for official use. Single dots, line or random shapes are not allowed. Please sign again clearly.',
};

export const CAMERA_ERROR_MESSAGE_CONSTANTS = {
    DEFAULT_ERROR_MESSAGE: 'Camera error occurred',
    DEFAULT_HYPERVERGE_ERROR_MESSAGE: 'Please try taking the photo again',
    IOS_REDIRECT_TITLE: 'Camera Not Available',
    IOS_REDIRECT_DESCRIPTION: 'Please use desktop for camera functionality',
    OTHER_REDIRECT_TITLE: 'Camera Not Supported',
    OTHER_REDIRECT_DESCRIPTION: 'Please use a supported browser',
};

export const PAN_ERROR_MESSAGE = {
    PAN_CANNOT_BE_EMPTY: 'PAN cannot be empty',
    PAN_MUST_BE_10_CHARACTERS_LONG: 'PAN must be 10 characters long',
    PAN_FORMAT_INVALID: 'PAN format invalid. Must be like ABCDE1234F',
    INVALID_PAN_TYPE_CHARACTER: 'Invalid PAN type character',
    INVALID_PAN_HOLDER_IDENTIFIER: 'Invalid PAN holder identifier',
};

export const USER_NAME_ERROR_MESSAGE = {
    NAME_CANNOT_BE_EMPTY: 'Name cannot be empty',
    NAME_MUST_BE_AT_LEAST_2_CHARACTERS_LONG:
        'Name must be at least 2 characters long',
    NAME_CANNOT_EXCEED_50_CHARACTERS: 'Name cannot exceed 50 characters',
    NAME_CAN_ONLY_CONTAIN_LETTERS_SPACES_DOT_OR_UNDERSCORE:
        'Name can only contain letters, spaces, dot or underscore',
    NAME_CANNOT_CONTAIN_CONSECUTIVE_DOTS_OR_UNDERSCORES:
        'Name cannot contain consecutive dots or underscores',
    NAME_CANNOT_START_OR_END_WITH_DOT_OR_UNDERSCORE:
        'Name cannot start or end with dot or underscore',
};

export const MOBILE_UPDATE_ERROR_MESSAGE = {
    INVALID_MOBILE_NUMBER: 'Please enter a valid mobile number',
    UPDATE_MOBILE_MATCH_ERROR:
        'Updated number should not be same as current number',
};

export const EMAIL_UPDATE_ERROR_MESSAGE = {
    INVALID_EMAIL: 'Please enter a valid email address',
    UPDATE_EMAIL_MATCH_ERROR:
        'New email should not be same as current email',
};

export const SCREEN_CONFIG_TITLE_SUBTITLE = {
    [ONBOARDING_FLOW_SCREENS.SELFIE]: { TITLE: 'Take Selfie' },
    [ONBOARDING_FLOW_SCREENS.ESIGN]: {
        TITLE: 'Aadhaar E-Sign',
        SUB_TITLE:
            'Your Aadhaar card must be linked to any mobile number to receive and confirm OTP ',
    },
};

export const ESIGN_AOF_JOURNEY_COPY: Record<
    string,
    { subHeading: string }
> = {
    [JOURNEY_TYPES.MAIN_ONBOARDING]: {
        subHeading:
            'Complete eSign using your Aadhaar to activate your account',
    },
    [JOURNEY_TYPES.HUF_ONBOARDING]: {
        subHeading:
            "Complete eSign with your Karta's Aadhaar to activate the HUF account",
    },
    [JOURNEY_TYPES.DDPI]: {
        subHeading:
            'Complete eSign using your Aadhaar to proceed with your DDPI request',
    },
    [JOURNEY_TYPES.NIO_ONBOARDING]: {
        subHeading:
            'Complete eSign using your Aadhaar to continue your application',
    },
    [JOURNEY_TYPES.FNO_INCOME_PROOF_DOC_UPLOAD]: {
        subHeading:
            'Complete eSign using your Aadhaar to submit your income proof',
    },
    'default': {
        subHeading: 'Complete eSign using your Aadhaar to the process',
    }
};


export const OS_TYPES = { IOS: 'iOS' };

export const HYPERVERGE_SDK_SCRIPT = {
    SCRIPT_ID: 'hyperkyc',
    SCRIPT_PATH: 'https://hv-web-sdk-cdn.hyperverge.co/hyperverge-web-sdk@10.8.0/src/sdk.min.js'
};

export const ERROR_MESSAGES = {
    GENERAL_ERROR: 'Something went wrong, Please try again later!!',
};

export const STATUS_BANNER_TYPE = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
};

export const DATA_POINT_STATUS = {
    SUBMITTED: 'SUBMITTED',
    NOT_SUBMITTED: 'NOT_SUBMITTED',
    REJECTED: 'REJECTED',
} as const;

export const CAMERA_BUTTON_TEXTS = {
    OPEN_CAMERA: 'Open Camera',
    RETRY: 'Retry',
    TAKE_AGAIN: 'Take Again',
    LOOKS_GOOD: 'Looks Good',
};

export const DIGILOCKER_COPY = {
    TITLE: 'Verify Aadhaar using OTP',
    HUF_TITLE: `Verify Karta's Aadhaar`,
    SUBTITLE: 'Enter your Aadhaar and verify using OTP sent to your Aadhaar linked mobile number',
    HUF_SUBTITLE: `Verify the Karta's Aadhaar to proceed with HUF account setup`,
    PROCEED: 'PROCEED FOR KYC',
    AADHAAR_NOT_LINKED: 'Aadhaar not linked to any mobile?',
    MANUAL_UPLOAD_CTA_TEXT: 'Upload your documents manually',
    SECURE_BY_COPY: 'Secured by DigiLocker, Govt. of India',
    MASKED_AADHAAR_DEFAULT: 'XXXX XXXX XXXX',

    // Loading states
    INITIALIZING: 'Initializing DigiLocker...',
    PROCESSING: 'Processing documents...',
    VERIFYING: 'Verifying with DigiLocker...',

    // Error states
    DIGILOCKER_UNAVAILABLE_HEADING: 'We are unable to verify your Aadhaar',
    DIGILOCKER_UNAVAILABLE_SUBHEADING_1: 'Error while initiating DigiLocker',
    DIGILOCKER_UNAVAILABLE_SUBHEADING_2: 'Please try again later',
    SERVICE_DOWN: 'DigiLocker service is temporarily unavailable',
    NETWORK_ERROR: 'Please check your internet connection',
    VERIFICATION_FAILED: 'Document verification failed',
    DOCUMENTS_NOT_FOUND: 'Required documents not found in DigiLocker',
    AADHAAR_NOT_LINKED_ERROR: 'Aadhaar not linked to mobile number',

    // Success states
    SUCCESS_HEADING: 'Documents Verified Successfully',
    SUCCESS_SUBHEADING: 'Your documents have been verified with DigiLocker',

    // Buttons
    RETRY: 'Retry',
    TRY_MANUAL: 'Try Manual Upload',
    CONTINUE: 'Continue',
} as const;

export const DIGILOCKER_VENDORS = {
    ELEMENTS: 'ELEMENTS',
    SETU: 'SETU',
    DIGIO: 'DIGIO',
} as const;

export const DIGILOCKER_DATA_POINTS = [
    'PROOF_OF_IDENTITY',
    'PROOF_OF_ADDRESS_FRONT',
    'PROOF_OF_ADDRESS_BACK',
    'IPV',
    'ADDRESS_TEXT',
] as const;


export const HYPERVERGE_ERROR_MESSAGES = {
    FACE_MASKED: 'Please remove face mask and try again',
    EYES_CLOSED: 'Please keep your eyes open',
    MULTIPLE_PEOPLE: 'Please ensure only one person is in frame',
    BROWSER_NOT_SUPPORTED:
        'Your browser is not supported. Please update or use a different browser.',
};

export const ADDRESS_PROOF_TYPES = {
    DRIVING_LICENCE: 'DL',
    VOTERID: 'VOTERID',
    PASSPORT: 'PASSPORT',
};

export const RAA_POPUP_TITLE = 'Running account authorization';

export const RAA_OPTIONS: Record<string, RAAOption> = {
    NINETY_DAYS: {
        value: 'NINETY_DAYS',
        title: 'For 90-days',
        description: 'Your account will be settled every 90 days.',
    },
    THIRTY_DAYS: {
        value: 'THIRTY_DAYS',
        title: 'For 30-days',
        description: 'Your account will be settled every 30 days.',
    },
    DAILY: {
        value: 'DAILY',
        title: 'On bill-to-bill basis',
        description:
            'Your account will be settled on a bill-to-bill basis, meaning after each transaction.',
    },
} as const;

export const STANDING_INSTRUCTIONS_LINK = 'https://groww.in/pages/standing-instructions-for-demat';

export const RAA_OPTIONS_LIST: RAAOption[] = Object.values(RAA_OPTIONS);

export const DATA_TYPE: Record<string, string> = {
    PAN_NO_INPUT_V2: 'PAN_NO_INPUT_V2',
    NAME: 'NAME',
    PAN_NO_CONFIRMATION: 'PAN_NO_CONFIRMATION',
    DOB: 'DOB',
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    ACCOUNT_FORM: 'ACCOUNT_FORM',
    MOBILE_NO_INPUT: 'MOBILE_NO_INPUT',
    EMAIL_INPUT: 'EMAIL_INPUT',
    INCOME_PROOF: 'INCOME_PROOF',
    OCCUPATION: 'OCCUPATION',
    TRADINGEXP: 'TRADINGEXP',
    NOMINEE: 'NOMINEE',
    GENDER: 'GENDER',
    SELFIE: 'SELFIE',
    SIGNATURE: 'SIGNATURE',
    PARENTS_NAME: 'PARENTS_NAME',
    MARITAL_STATUS: 'MARITAL_STATUS',
    INCOME_RANGE: 'INCOME_RANGE',
    NOMINEE_OTP: 'NOMINEE_OTP',
    LOCATION_VALIDATION: 'LOCATION_VALIDATION',
    PAYMENT_CONFIRMATION: 'PAYMENT_CONFIRMATION',
    KYC_DECLARATION: 'KYC_DECLARATION',
    // DigiLocker data types
    PROOF_OF_IDENTITY: 'PROOF_OF_IDENTITY',
    PROOF_OF_ADDRESS_FRONT: 'PROOF_OF_ADDRESS_FRONT',
    PROOF_OF_ADDRESS_BACK: 'PROOF_OF_ADDRESS_BACK',
    IPV: 'IPV',
    ADDRESS_TEXT: 'ADDRESS_TEXT',
    SEAL_AND_SIGNATURE: 'SEAL_AND_SIGNATURE',
    COPARCENER: 'COPARCENER',
    KARTHA_PAN: 'KARTHA_PAN',
    KARTHA_NAME: 'KARTHA_NAME',
    KARTHA_DOB: 'KARTHA_DOB',
    KARTHA_ADDRESS: 'KARTHA_ADDRESS',
    BANK_PROOF: 'BANK_PROOF'
} as const;

export const SUBMISSION_MODE = {
    AADHAAR_ESIGN: 'AADHAAR_ESIGN',
    EKYC: 'EKYC',
    OTP: 'OTP',
    USER_INPUT: 'USER_INPUT',
    NOMINEE_ADDITION_WITHOUT_CONTEXT: 'NOMINEE_ADDITION_WITHOUT_CONTEXT',
    NOMINEE_EDIT_WITHOUT_CONTEXT: 'NOMINEE_EDIT_WITHOUT_CONTEXT',
    USER_INPUT_NAME_MODIFICATION: 'USER_INPUT_NAME_MODIFICATION',
    NOMINEE_EDIT: 'NOMINEE_EDIT',
    NIO_DIGILOCKER: 'NIO_DIGILOCKER',
    AUTO_FETCH_PAN: 'AUTO_FETCH_PAN',
    AUTO_FETCH_NAME: 'AUTO_FETCH_NAME',
    AUTO_FETCH_BANK: 'AUTO_FETCH_BANK',
    REVERSE_PENNY_DROP: 'REVERSE_PENNY_DROP',
    PENNY_DROP: 'PENNY_DROP',
    DIGILOCKER: 'DIGILOCKER',
    GEOLOCATION: 'GEOLOCATION',
    IP_STACK: 'IP_STACK',
} as const;

export const STOCK_STATUS = {
    COMPLETED: 'COMPLETED',
    NOT_COMPLETED: 'NOT_COMPLETED',
    VERIFIED: 'VERIFIED',
    PENDING: 'PENDING'
};

export const FNO_STATUS = {
    COMPLETED: 'COMPLETED',
    NOT_COMPLETED: 'NOT_COMPLETED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
};

export const API_RESPONSE_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
};

export const COSMOS_POLL_STATUS = {
    SUCCESS: 'SUCCESS',
    CONTINUE: 'CONTINUE',
    FAILED: 'FAILED',
};

export const DATA_INITIALISATION_STATUS = {
    SUCCESS: 'SUCCESS',
};

export const DATA_SUBMISSION_STATUS = {
    SUCCESS: 'SUCCESS',
    REJECTED: 'REJECTED'
};

export const MODE_TO_SCREEN_MAP: Record<string, Record<string, string>> = {
    [DATA_TYPE.PAN_NO_INPUT_V2]: {
        [SUBMISSION_MODE.AUTO_FETCH_PAN]:
            ONBOARDING_FLOW_SCREENS.PAN_AUTO_FETCH_SCREEN,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.PAN_INPUT_SCREEN,
    },
    [DATA_TYPE.NAME]: {
        [SUBMISSION_MODE.AUTO_FETCH_NAME]:
            ONBOARDING_FLOW_SCREENS.NAME_AUTO_FETCH_SCREEN,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.NAME_INPUT_SCREEN,
        [SUBMISSION_MODE.USER_INPUT_NAME_MODIFICATION]:
            ONBOARDING_FLOW_SCREENS.NAME_MISMATCH_SCREEN,
    },
    [DATA_TYPE.PAN_NO_CONFIRMATION]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.PAN_NO_CONFIRMATION,
    },
    [DATA_TYPE.DOB]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.DOB_SCREEN,
    },
    [DATA_TYPE.BANK_ACCOUNT]: {
        [SUBMISSION_MODE.AUTO_FETCH_BANK]: ONBOARDING_FLOW_SCREENS.AUTO_FETCH_BANK,
        [SUBMISSION_MODE.REVERSE_PENNY_DROP]:
            ONBOARDING_FLOW_SCREENS.BANK_RPD_SCREEN,
        [SUBMISSION_MODE.PENNY_DROP]: ONBOARDING_FLOW_SCREENS.BANK_PD_SCREEN,
    },
    [DATA_TYPE.TRADINGEXP]: {
        [SUBMISSION_MODE.USER_INPUT]:
            ONBOARDING_FLOW_SCREENS.TRADING_EXPERIENCE_SCREEN,
    },
    [DATA_TYPE.KYC_DECLARATION]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.KYC_DECLARATION
    },
    [DATA_TYPE.OCCUPATION]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.OCCUPATION_SCREEN,
    },
    [DATA_TYPE.GENDER]: {
        [SUBMISSION_MODE.USER_INPUT]:
            ONBOARDING_FLOW_SCREENS.GENDER_SELECTION_SCREEN,
    },
    [DATA_TYPE.PARENTS_NAME]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.FATHERS_NAME_SCREEN,
    },
    [DATA_TYPE.MARITAL_STATUS]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.MARITAL_STATUS,
    },
    [DATA_TYPE.INCOME_RANGE]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.INCOME_RANGE,
    },
    [DATA_TYPE.SELFIE]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.SELFIE,
    },
    [DATA_TYPE.SIGNATURE]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.SIGNATURE,
    },
    [DATA_TYPE.EMAIL_INPUT]: {
        [SUBMISSION_MODE.OTP]: ONBOARDING_FLOW_SCREENS.EMAIL_INPUT,
    },
    [DATA_TYPE.MOBILE_NO_INPUT]: {
        [SUBMISSION_MODE.OTP]: ONBOARDING_FLOW_SCREENS.MOBILE_INPUT,
    },
    [DATA_TYPE.ACCOUNT_FORM]: {
        [SUBMISSION_MODE.AADHAAR_ESIGN]: ONBOARDING_FLOW_SCREENS.ESIGN,
    },
    [DATA_TYPE.INCOME_PROOF]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.INCOME_PROOF,
    },
    [DATA_TYPE.NOMINEE]: {
        [SUBMISSION_MODE.NOMINEE_ADDITION_WITHOUT_CONTEXT]:
            ONBOARDING_FLOW_SCREENS.NOMINEE_ADDITION,
        [SUBMISSION_MODE.NOMINEE_EDIT_WITHOUT_CONTEXT]:
            ONBOARDING_FLOW_SCREENS.NOMINEE_ADDITION,
        [SUBMISSION_MODE.NOMINEE_EDIT]: ONBOARDING_FLOW_SCREENS.NOMINEE_ADDITION,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.NOMINEE_ADDITION,
    },
    [DATA_TYPE.NOMINEE_OTP]: {
        [SUBMISSION_MODE.OTP]: ONBOARDING_FLOW_SCREENS.NOMINEE_EDIT_OTP,
    },
    [DATA_TYPE.LOCATION_VALIDATION]: {
        [SUBMISSION_MODE.GEOLOCATION]: ONBOARDING_FLOW_SCREENS.LOCATION_VALIDATION,
        [SUBMISSION_MODE.IP_STACK]: ONBOARDING_FLOW_SCREENS.LOCATION_VALIDATION,
    },
    [DATA_TYPE.PROOF_OF_IDENTITY]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.PROOF_OF_IDENTITY,
    },
    [DATA_TYPE.PROOF_OF_ADDRESS_FRONT]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.MANUAL_DOC_UPLOAD,
    },
    [DATA_TYPE.PROOF_OF_ADDRESS_BACK]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.MANUAL_DOC_UPLOAD,
    },
    [DATA_TYPE.IPV]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.IPV,
    },
    [DATA_TYPE.ADDRESS_TEXT]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.ADDRESS_TEXT,
    },
    [DATA_TYPE.SEAL_AND_SIGNATURE]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.SIGNATURE,
    },
    [DATA_TYPE.COPARCENER]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.COPARCENER_DETAIL_SCREEN,
    },
    [DATA_TYPE.KARTHA_PAN]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.PAN_INPUT_SCREEN,
    },
    [DATA_TYPE.KARTHA_NAME]: {
        [SUBMISSION_MODE.AUTO_FETCH_NAME]: ONBOARDING_FLOW_SCREENS.NAME_AUTO_FETCH_SCREEN,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.NAME_INPUT_SCREEN
    },
    [DATA_TYPE.KARTHA_DOB]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.DOB_SCREEN
    },
    [DATA_TYPE.KARTHA_ADDRESS]: {
        [SUBMISSION_MODE.EKYC]: ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN,
        [SUBMISSION_MODE.DIGILOCKER]: ONBOARDING_FLOW_SCREENS.DIGILOCKER,
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.ADDRESS_TEXT,
    },
    [DATA_TYPE.BANK_PROOF]: {
        [SUBMISSION_MODE.USER_INPUT]: ONBOARDING_FLOW_SCREENS.MANUAL_DOC_UPLOAD,
    },
};

// EKYC specific constants
export const EKYC_CONSTANTS = {
    ID_TYPES: {
        AADHAAR: 'AADHAAR',
        VID: 'VID',
    },
    OTP_LENGTH: 6,
    RESEND_OTP_TIMER: 90, // seconds
    MAX_OTP_ATTEMPTS: 3,
    ERROR_TYPES: {
        INCORRECT_OTP: 'INCORRECT_OTP',
        UIDAI_DATA_ERROR: 'UIDAI_DATA_ERROR',
        NETWORK_ERROR: 'NETWORK_ERROR',
        MAX_ATTEMPTS_REACHED: 'MAX_ATTEMPTS_REACHED',
    },
};

export const EKYC_COPY = {
    CONSENT_TITLE: 'Verify Aadhaar using OTP',
    HUF_CONSENT_TITLE: `Verify Karta's Aadhaar using OTP`,
    CONSENT_SUBTITLE:
        'Enter your Aadhaar and verify using OTP sent to your Aadhaar linked mobile number',
    AADHAAR_TITLE: 'Enter Aadhaar Details',
    HUF_AADHAAR_TITLE: `Enter Karta's Aadhaar Details`,
    VID_TITLE: 'Enter VID Details',
    HUF_VID_TITLE: `Enter Karta's VID Details`,
    AADHAAR_SUBTITLE: 'Provide your Aadhaar number or VID for verification',
    HUF_AADHAAR_SUBTITLE: `Provide the Karta's Aadhaar number or VID for verification`,
    OTP_TITLE: 'Verify OTP',
    HUF_OTP_TITLE: `Verify Karta's Aadhaar OTP`,
    OTP_SUBTITLE: 'Enter the OTP sent to your Aadhaar-linked mobile number',
    HUF_OTP_SUBTITLE: `Enter the OTP sent to the Karta's Aadhaar-linked mobile number`,
    CONFIRMATION_TITLE: 'Confirm Your Details',
    CONFIRMATION_SUBTITLE:
        'Please verify the information extracted from your Aadhaar',
    ERROR_TITLE: 'Verification Failed',
    ERROR_SUBTITLE: 'There was an issue with your eKYC verification',

    // Button labels
    PROVIDE_CONSENT: 'Continue',
    SEND_OTP: 'SEND OTP',
    VERIFY_OTP: 'VERIFY OTP',
    CONFIRM_DETAILS: 'CONFIRM DETAILS',
    TRY_AGAIN: 'TRY AGAIN',
    RESEND_OTP: 'RESEND OTP',
    SKIP_EKYC: 'SKIP eKYC',

    // Input placeholders
    AADHAAR_PLACEHOLDER: 'Enter 12-digit Aadhaar number',
    VID_PLACEHOLDER: 'Enter 16-digit VID',
    OTP_PLACEHOLDER: 'Enter 6-digit OTP',

    // Messages
    OTP_SENT_MESSAGE: 'OTP sent to your Aadhaar-linked mobile number',
    RESEND_OTP_MESSAGE: 'Resend OTP in',
    INVALID_AADHAAR: 'Please enter a valid 12-digit Aadhaar number',
    INVALID_VID: 'Please enter a valid 16-digit VID',
    INVALID_OTP: 'Please enter a valid 6-digit OTP',
};

export const ONB_BUTTON_PLACEHOLDERS = {
    VERIFY: 'VERIFY',
    LOOKS_GOOD: 'LOOKS GOOD',
    RE_UPLOAD: 'RE-UPLOAD',
    UPLOAD_PHOTO: 'UPLOAD PHOTO',
    VERIFY_USING_UPI_ID: 'Verify using UPI ID',
    VERIFY_BANK: 'VERIFY BANK',
    CLICK_TO_ACTIVATE: 'CLICK TO ACTIVATE',
    UPLOAD_INCOME_PROOF: 'UPLOAD INCOME PROOF',
    SUBMIT_INCOME_PROOF: 'SUBMIT INCOME PROOF',
    LETS_GO: "LET'S GO",
};

export const BANK_VERIFICATION_SCREENS = {
    BANK_SELECTION: 'BANK_SELECTION',
    BRANCH_SELECTION: 'BRANCH_SELECTION',
    ACCOUNT_NUMBER_VERIFICATION: 'ACCOUNT_NUMBER_VERIFICATION',
};

export enum COMMODITIES_ONBOARDING_STATES {
    NOT_COMPLETED = 'NOT_COMPLETED',
    PENDING = 'PENDING',
    NSE_DONE_MCX_PENDING = 'NSE_DONE_MCX_PENDING',
    NSE_PENDING_MCX_DONE = 'NSE_PENDING_MCX_DONE',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    CLOSED = 'CLOSED',
    BLOCKED = 'BLOCKED',
    INACTIVE = 'INACTIVE',
    DEACTIVATED = 'DEACTIVATED',
}

export enum EXCHANGES {
    NSE = 'NSE',
    BSE = 'BSE',
    MCX = 'MCX',
    NCDEX = 'NCDEX',
}

export const POLL_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    CONTINUE: 'CONTINUE',
}
// — KYC Declaration config —

export const DECLARATION_CONFIG: DeclarationItem[] = [
    {
        type: 'segments',
        title: 'Trade in these exchanges/segments',
        options: [
            {
                id: 'cashEquity',
                label: 'Cash (equity) / Mutual Funds',
                defaultChecked: true,
                disabled: true,
                checkboxIds: ['nse', 'bse', 'mf'],
            },
            { id: 'equityFNO', label: 'Equity F&O', checkboxIds: ['fno'], defaultChecked: false, disabled: false },
            { id: 'commodities', label: 'Commodities', checkboxIds: ['mcxCommodities'], defaultChecked: false, disabled: false },
            { id: 'debt', label: 'Debt', checkboxIds: ['nseDebt', 'bseDebt'], defaultChecked: false, disabled: false },
        ],
    },
    {
        type: 'checkbox',
        key: 'NOT_A_PEP',
        title: 'Not a politically exposed person (PEP)',
        defaultChecked: true,
        disablesContinue: true,
    },
    {
        type: 'checkbox',
        key: 'ECN_AND_COMMUNICATIONS',
        title: 'Receive ECN and other communications on email',
        defaultChecked: true,
        disablesContinue: true,
    },
    {
        type: 'checkbox',
        key: 'STANDING_INSTRUCTIONS',
        title: 'Standing instructions agreement',
        defaultChecked: true,
        disablesContinue: true,
    },
    {
        type: 'proceedings',
        key: 'REGULATORY_PROCEEDINGS',
        title: 'No regulatory proceedings or SEBI relation',
        subtitle:
            'I am not related to one and have no pending/past proceedings by SEBI or any authority in the last 3 years.',
        defaultChecked: true,
        modalTitle: 'Past actions/proceedings by brokers',
        modalPlaceholder:
            'Please mention any action/proceedings initiated/pending/taken by SEBI/Stock exchange/any other authority in the last 3 years.',
    },
    {
        type: 'brokers',
        key: 'STOCK_BROKING_ACCOUNT',
        title: 'No existing stock broking account',
        subtitle: 'I do not have any active stock broking account linked with another broker.',
        defaultChecked: true,
        modalTitle: 'Active stock broking account',
        options: [
            { id: 'zerodha', label: 'Zerodha' },
            { id: 'angel', label: 'Angel One' },
            { id: 'upstox', label: 'Upstox' },
            { id: 'icici', label: 'ICICI Direct' },
            { id: 'other', label: 'Other' },
        ],
    },
];


export const PAN_TYPE = {
    HUF: 'H',
    CORPORATE: 'C',
    INDIVIDUAL: 'I',
};

export const HYPERVERGE_RESPONSE = {
    AUTO_APPROVED: 'auto_approved',
    AUTO_DECLINED: 'auto_declined',
    USER_CANCELLED: 'user_cancelled',
    ERROR: 'error'
};

export const HYPERVERGE_WORKFLOW_ID = 'selfie';

export const CONTENT_TYPES = {
    PDF: 'application/pdf',
    IMAGE: 'image/jpeg'
}
